import { render, staticRenderFns } from "./lab_category.vue?vue&type=template&id=3d3004c4&scoped=true&"
import script from "./lab_category.vue?vue&type=script&lang=js&"
export * from "./lab_category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3004c4",
  null
  
)

export default component.exports